<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <span class="label"></span>
            <div class="cell">
              <select v-model="formData.range">
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="YEARLY">년간</option>
              </select>

              <DatePicker
                v-if="formData.range === 'DAILY'"
                :value="$utils.calcDate(null, '-1d')"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <WeekPicker
                v-if="formData.range === 'WEEKLY'"
                class="blank"
                width="300px"
                ref="picker"
                :value="$utils.calcDate(null, '-1w')"
                :maxDate="new Date()"
              />
              <MonthPicker v-if="formData.range === 'MONTHLY'" class="blank" ref="picker" :maxDate="new Date()" />
              <YearPicker v-if="formData.range === 'YEARLY'" class="blank" ref="picker" minDate="2017" :maxDate="new Date()" />
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector permissionCode="statistic" :initArea="$route.query.area" :useGroup="false" ref="groupSelector" />
            </div>
          </div>
          <div class="row">
            <span class="label"></span>
            <div class="cell">
              <select v-model="formData.useStatus">
                <option value>이용상태</option>
                <option value="USE">이용중</option>
                <option value="NOTUSE">해제</option>
              </select>

              <select v-model="formData.age">
                <option value>연령대</option>
                <option value="50">50대</option>
                <option value="60">60대</option>
                <option value="70">70대</option>
                <option value="80">80대</option>
                <option value="90">90대 이상</option>
              </select>

              <select v-model="formData.gender">
                <option value>성별</option>
                <option value="F">여성</option>
                <option value="M">남성</option>
              </select>
            </div>

            <span class="label">검색</span>
            <div class="cell">
              <select v-model="formData.searchType">
                <option value="NAME">이름</option>
                <option value="TID">TID</option>
              </select>
              <input type="text" class="inp_text blank" style="width: 258px" v-model.trim="formData.searchValue" ref="searchInput" />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <template v-if="res">
      <h4 v-if="res" class="section_title">
        <span class="ico"></span>검색결과 :
        <span class="highlight">{{ res.searchCount || 0 }}</span>
        <p class="desc">
          <strong>등록된 대상자수</strong>
          : {{ res.userCount || 0 }}명
        </p>
      </h4>

      <PagingTable :sourceList="res.userStatDataList" :itemPerPage="50" ref="table">
        <template #header>
          <caption>
            <span class="blind">통계 목록</span>
          </caption>
          <colgroup>
            <col width="5%" />
            <col width="6%" />
            <col width="9%" />
            <col width="8%" />
            <col width="100px" />
          </colgroup>

          <thead class="table_list_head table_list_head_line">
            <tr>
              <th rowspan="3" class="sorting" data-sort="rcpName">이름</th>
              <th rowspan="3" class="sorting" data-sort="rcpGenderAndAge">성별/나이</th>
              <th rowspan="3" class="sorting" data-sort="group">그룹</th>
              <th rowspan="3" class="sorting" data-sort="tid">TID</th>
              <th rowspan="3" class="sorting" data-sort="recentDate">
                최근
                <br />이용날짜 <br />(6개월 이내)
              </th>
              <th colspan="11">조회기간별 통계</th>
              <th colspan="7">누적 통계 (최근 6개월, 조회기간 무관)</th>
            </tr>
            <tr>
              <th colspan="2">일반소식</th>
              <th colspan="2">반복소식</th>
              <th>맞춤소식</th>
              <th colspan="2">두뇌톡톡</th>
              <th colspan="2">기억검사</th>
              <th>좋은생각</th>
              <th>마음체조</th>
              <th colspan="4">두뇌톡톡</th>
              <th colspan="3">기억검사</th>
            </tr>
            <tr>
              <th class="sorting" data-sort="newsNormalRequestCount">전송</th>
              <th class="sorting" data-sort="newsNormalReadCount">확인</th>
              <th class="sorting" data-sort="newsRepeatRequestCount">전송</th>
              <th class="sorting" data-sort="newsRepeatReadCount">확인</th>
              <th class="sorting" data-sort="newsCustomRequestCount">전송</th>
              <th class="sorting" data-sort="gameStartCount">호출</th>
              <th class="sorting" data-sort="gameFinalCount">완료</th>
              <th class="sorting" data-sort="dementiaStartCount">호출</th>
              <th class="sorting" data-sort="dementiaFinalCount">완료</th>
              <th class="sorting" data-sort="goodStartCount">호출</th>
              <th class="sorting" data-sort="mindStartCount">호출</th>

              <th class="sorting" data-sort="accumGameAvgScore">평균점수</th>
              <th class="sorting" data-sort="accumGameStartCount">호출</th>
              <th class="sorting" data-sort="accumGameFinalCount">완료</th>
              <th class="sorting" data-sort="accumGameFinalDateCount">완료일수</th>
              <th class="sorting" data-sort="accumDementiaLatestStatus">최근결과</th>
              <th class="sorting" data-sort="accumDementiaStartCount">호출</th>
              <th class="sorting" data-sort="accumDementiaFinalCount">완료</th>
            </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr>
            <td>
              <router-link :to="`/stats/v2/user/${rowData.rcpId}`" class="link_modal">{{ rowData.rcpName }} </router-link>
            </td>
            <td>{{ rowData.rcpGenderAndAge }}</td>
            <td class="left">{{ rowData.group }}</td>
            <td class="left">{{ rowData.tid }}</td>
            <td>{{ rowData.recentDate }}</td>
            <td>{{ rowData.newsNormalRequestCount }}</td>
            <td>{{ rowData.newsNormalReadCount }}</td>
            <td>{{ rowData.newsRepeatRequestCount }}</td>
            <td>{{ rowData.newsRepeatReadCount }}</td>
            <td>{{ rowData.newsCustomRequestCount }}</td>
            <td>{{ rowData.gameStartCount }}</td>
            <td>{{ rowData.gameFinalCount }}</td>
            <td>{{ rowData.dementiaStartCount }}</td>
            <td>{{ rowData.dementiaFinalCount }}</td>
            <td>{{ rowData.goodStartCount }}</td>
            <td>{{ rowData.mindStartCount }}</td>

            <td>{{ rowData.accumGameAvgScore }}</td>
            <td>{{ rowData.accumGameStartCount }}</td>
            <td>{{ rowData.accumGameFinalCount }}</td>
            <td>{{ rowData.accumGameFinalDateCount }}</td>
            <td>{{ rowData.accumDementiaLatestStatus }}</td>
            <td>{{ rowData.accumDementiaStartCount }}</td>
            <td>{{ rowData.accumDementiaFinalCount }}</td>
          </tr>
        </template>
      </PagingTable>

      <div class="section_button none_paginate">
        <ExcelDownloadButton :filename="$utils.excelName('대상자별통계')">
          <ExcelTable :sourceList="res.userStatDataList" />
        </ExcelDownloadButton>
        <HelpButton contentId="HELP_06" />
      </div>
    </template>
  </section>
</template>

<script>
import ExcelTable from './index.excel';

export default {
  components: {ExcelTable},
  data() {
    return {
      res: null,
      formData: {
        range: 'WEEKLY',
        state: '',
        city: '',
        useStatus: '',
        age: '',
        gender: '',
        searchType: 'NAME',
        searchValue: '',
      },
    };
  },
  methods: {
    requestOptions() {
      const startDate = this.$refs.picker.getDate();
      const group = this.$refs.groupSelector.getData();

      return {
        params: _.merge(this.formData, {
          searchDate: this.$utils.dateText(startDate),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId,
        }),
      };
    },
    loadData() {
      if (this.$utils.hasSpecialChar(this.formData.searchValue)) {
        alert('특수문자를 제외하고 검색해 주세요.');
        this.$refs.searchInput.focus();
        return;
      }
      const options = this.requestOptions();
      this.$axios.get('/admin/happy/stats/v2/user', options).then(({data}) => {
        // 정렬하기 위해 데이터 펼침
        data.userStatDataList.forEach((item) => {
          item.rcpGenderAndAge = `${item.rcpGender}/${item.rcpAge}`;
          Object.assign(item, item.userSearchStatData);
          Object.assign(item, item.userAccumulateStatData);
        });
        this.res = data;
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
